module.exports = __webpack_public_path__ + "static/WAI_SS_01-efa4daa589d9d9a2e65c934ef98444d8.png";